import { render, staticRenderFns } from "./PromotionalDialog.vue?vue&type=template&id=44d97e8a&scoped=true"
import script from "./PromotionalDialog.vue?vue&type=script&lang=js"
export * from "./PromotionalDialog.vue?vue&type=script&lang=js"
import style0 from "./PromotionalDialog.vue?vue&type=style&index=0&id=44d97e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d97e8a",
  null
  
)

export default component.exports